import React from "react";
import QuoteStepBase, { mapDriverStepProps } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import Question from '../components/Question'
import { Button } from 'react-bootstrap'
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, MARIED_TYPES, YES_NO } from "../AppConstants";
import Utilities from "../classes/Utilities";
import { IAppState } from "../state/interfaces";
import ReactLoading from 'react-loading';
import { IQuoteApiClient, IPaths, ILOBApiClient, IViolationList, IDriver, IIncidentInfo, IToolTipOption } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import IncidentInfo from "../components/IncidentInfo";
import moment from "moment";


interface IState extends IQuoteStepState {
    driver: IDriver,
    licenseSuspendedRevokedFiveYears: string,
    sr22: string,
    studentGood: string,
    defensiveDriver: string,
    physiciansReport: string,
    accidentsViolations: string,
    updatingStore: boolean,
    addDriverClick: boolean,
    continueClick: boolean,
    loadingViolationsList: boolean
}

interface IDrivingHistoryProps extends IDriverStepProps {
    driversCount: number,
    driver: IDriver,
    insured: IDriver,
    secondDriver: IDriver,
    driverAge: number,
    violationList: IViolationList,
    updateViolationList: (update: any) => Promise<any>;
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    stateCode: string,
    PATHS: IPaths;
}

class DrivingHistory extends QuoteStepBase<IDrivingHistoryProps, IState> {
    constructor(props: IDrivingHistoryProps) {
        super(props);
        this.next = this.next.bind(this);
        this.onAccidentsViolationsChange = this.onAccidentsViolationsChange.bind(this);
        this.onIncidentChange = this.onIncidentChange.bind(this);
        this.onIncidentDelete = this.onIncidentDelete.bind(this);
        this.onIncidentAdd = this.onIncidentAdd.bind(this);

        this.state = {
            driver: this.props.driver,
            licenseSuspendedRevokedFiveYears : "",
            sr22: "",
            studentGood: "",
            defensiveDriver: "",
            physiciansReport: "",
            accidentsViolations: "",
            updatingStore: false,
            addDriverClick: false,
            continueClick: false,
            loadingViolationsList: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    subscribeToValidation() {
        validationUtils.subscribeToValidationFailure(QUOTE_STEPS.DRIVING_HISTORY,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, continueClick: false, addDriverClick: false, errors: validationData });
            });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;

            return {
                ...prevState,
                licenseSuspendedRevokedFiveYears: !!driver.licenseSuspendedRevokedFiveYears ? driver.licenseSuspendedRevokedFiveYears : QUOTE_QUESTIONS.YES_NO.NO,
                sr22: !!driver.sr22 ? driver.sr22 : "",
                studentGood: !!driver.studentGood ? driver.studentGood : QUOTE_QUESTIONS.YES_NO.NO,
                defensiveDriver: !!driver.defensiveDriver ? driver.defensiveDriver : QUOTE_QUESTIONS.YES_NO.NO,
                physiciansReport: !!driver.physiciansReport ? driver.physiciansReport : QUOTE_QUESTIONS.YES_NO.NO,
                accidentsViolations: !!driver.accidentsViolations ? driver.accidentsViolations : QUOTE_QUESTIONS.YES_NO.NO
            };
        }

        return prevState;
    }

    bodyNext() {
        this.setState({ updatingStore: true, continueClick: true, addDriverClick: false }, () => {
            const updatedDriver = {
                ...this.props.driver,
                licenseSuspendedRevokedFiveYears: this.state.licenseSuspendedRevokedFiveYears,
                sr22: this.state.sr22,
                studentGood: this.state.studentGood,
                defensiveDriver: this.state.defensiveDriver,
                physiciansReport: this.state.physiciansReport,
                accidentsViolations: this.state.accidentsViolations
            };

            var nextUrl = this.props.driverIndex < this.props.driversCount - 1
                ? Utilities.formatUrl(this.props.PATHS.ABOUT_YOU, (this.props.driverIndex + 1).toString())
                : Utilities.formatUrl(this.props.PATHS.NEW_POLICY, "");

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(nextUrl),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        if (this.props.driverIndex == 0 && MARIED_TYPES.includes(this.props.driver.maritalStatus)) {

            if (this.props.secondDriver) {
                this.bodyNext();
            }
            else {
                this.onAddDriverClick();
            }
        }
        else {
            this.bodyNext();
        }
    }

    callbackFunctionLicense = (childData:string) => {
        switch (childData) {
            case "Yes":
                this.setState({visible: true});
                break;
            case "No":
                this.setState({visible: false});
                break;
        }
    };

    onAddDriverClick() {
        this.setState({ updatingStore: true, continueClick: false, addDriverClick: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                licenseSuspendedRevokedFiveYears: this.state.licenseSuspendedRevokedFiveYears,
                sr22: this.state.sr22,
                studentGood: this.state.studentGood,
                defensiveDriver: this.state.defensiveDriver,
                physiciansReport: this.state.physiciansReport,
                accidentsViolations: this.state.accidentsViolations
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.ABOUT_YOU, this.props.driversCount.toString())),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    onAccidentsViolationsChange(value: string) {
        const violationsApiClient = this.props.lobApiClient;

        this.setState({ updatingStore: true, loadingViolationsList: true }, () => {
            let _driver = this.state.driver;
            _driver.sr22 = this.state.sr22;
            _driver.studentGood = this.state.studentGood;
            _driver.defensiveDriver = this.state.defensiveDriver;
            _driver.physiciansReport = this.state.physiciansReport;

            if (value == QUOTE_QUESTIONS.YES_NO.YES) {
                if (!this.state.driver.incidents || this.state.driver.incidents.length == 0) {
                    let incendent: IIncidentInfo = {
                        category: "",
                        violation: "",
                        violationCode: "",
                        violationDate: moment(new Date()).toDate(),
                        convictionDate: null
                    };

                    _driver.incidents = new Array<IIncidentInfo>();
                    _driver.incidents.push(incendent);
                }
            }
            else {
                if (this.state.driver.incidents && this.state.driver.incidents.length > 0) {
                    _driver.incidents = new Array<IIncidentInfo>();
                }
            }

            if (this.props.violationList == null) {
                violationsApiClient.getViolationList(this.props.stateCode)
                    .then((response) => {
                        this.props.updateViolationList(response.data)
                            .then(() => this.setState({ ...this.state, updatingStore: false, loadingViolationsList: false, accidentsViolations: value, driver: _driver }),
                                () => {
                                    this.setState({ ...this.state, updatingStore: false, loadingViolationsList: false });
                                });
                    },
                    () => {
                        this.setState({ ...this.state, updatingStore: false, loadingViolationsList: false })
                    });
            }
            else {
                this.setState({ ...this.state, updatingStore: false, loadingViolationsList: false, accidentsViolations: value, driver: _driver });
            }
        });
    }

    onIncidentChange(incident: IIncidentInfo, index: number) {
        let _driver = this.state.driver;
        _driver.incidents[index] = incident;

        this.setState({ ...this.state, driver: _driver });
    }

    onIncidentDelete(index: number) {
        let _driver = this.state.driver;

        if (_driver.incidents.length > index) {
            if (index == 0 && _driver.incidents.length == 1) {
                let incendent: IIncidentInfo = {
                    category: "",
                    violation: "",
                    violationCode: "",
                    violationDate: new Date(),
                    convictionDate: null
                };

                _driver.incidents = new Array<IIncidentInfo>();
                _driver.incidents.push(incendent);
            }
            else {
                _driver.incidents.splice(index, 1);
            }

            this.setState({ ...this.state, driver: _driver });
        }
    }

    onIncidentAdd() {
        let _driver = this.state.driver;
        let incendent: IIncidentInfo = {
            category: "",
            violation: "",
            violationCode: "",
            violationDate: new Date(),
            convictionDate: null
        };

        _driver.incidents.push(incendent);

        this.setState({ ...this.state, driver: _driver });
    }

    getDescription() {
        let drNumber = this.props.driverIndex + 1;

        if (this.props.driverIndex == 0) {
            return "YOUR DRIVING HISTORY";
        }
        else if (this.props.driverIndex == 1 && MARIED_TYPES.includes(this.props.insured.maritalStatus)) {
            return 'YOUR SPOUSE (' + this.props.driver.firstName + ' ' + this.props.driver.lastName + ') DRIVING HISTORY';
        }
        else {
            return 'DRIVER #' + drNumber + ' (' + this.props.driver.firstName + ' ' + this.props.driver.lastName + ') DRIVING HISTORY';
        }
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea">
                        <h5>
                            {!this.props.driver.isExcluded ? this.getDescription() : "ADD THE NEXT DRIVER IF NECESSARY"}
                        </h5>
                    </div>

                    {
                        //<Question
                        //    name="licenseSuspendedRevokedFiveYears"
                        //    selected={(v) => { this.setStateValue(v, "licenseSuspendedRevokedFiveYears") }}
                        //    selectedValue={this.state.licenseSuspendedRevokedFiveYears}
                        //    error={validationUtils.getValidationErrorFor(this.state.errors, "licenseSuspendedRevokedFiveYears")}
                        //    items={[
                        //        QUOTE_QUESTIONS.YES_NO.YES,
                        //        QUOTE_QUESTIONS.YES_NO.NO
                        //    ]}
                        //    lable="Has your license been suspended or revoked in the last 5 years?" />
                    }
                    {
                        this.props.stateCode === "TX"
                        ?
                            !this.props.driver.isExcluded
                            ?
                                <Question
                                    name="sr22"
                                    selected={(v) => { this.setStateValue(v, "sr22") }}
                                    selectedValue={this.state.sr22}
                                    error={validationUtils.getValidationErrorFor(this.state.errors, "sr22")}
                                    items={[
                                        QUOTE_QUESTIONS.YES_NO.YES,
                                        QUOTE_QUESTIONS.YES_NO.NO
                                   ]}
                                   lable="Are you required to have an SR-22 or other Financial Responsibility document?"
                                />
                            :
                            null
                        :
                        null
                    }

                    {
                        !this.props.driver.isExcluded && this.props.driverAge >= 16 && this.props.driverAge <= 25
                        ?
                        <Question
                            name="studentGood"
                            selected={(v) => { this.setStateValue(v, "studentGood") }}
                            selectedValue={this.state.studentGood}
                            error={validationUtils.getValidationErrorFor(this.state.errors, "studentGood")}
                            items={[
                                QUOTE_QUESTIONS.YES_NO.YES,
                                QUOTE_QUESTIONS.YES_NO.NO
                            ]}
                            lable={this.props.driverIndex == 0
                                ? "Are you eligible for Academic Standing Discount?"
                                : 'Are ' + this.props.driver.firstName.toUpperCase() + ' ' + this.props.driver.lastName.toUpperCase() + ' eligible for Academic Standing Discount?'}
                            tooltip={{ title: "Academic Standing", content: "Need proof of full time student in upper 20% of class OR B Average (3.0 GPA or higher) or Dean's List." } as IToolTipOption}
                            />
                        :null
                    }

                    {
                        !this.props.driver.isExcluded && this.props.driverAge >= 55
                        ?
                        <Question
                            name="defensiveDriver"
                            selected={(v) => { this.setStateValue(v, "defensiveDriver") }}
                            selectedValue={this.state.defensiveDriver}
                            error={validationUtils.getValidationErrorFor(this.state.errors, "defensiveDriver")}
                            items={[
                                QUOTE_QUESTIONS.YES_NO.YES,
                                QUOTE_QUESTIONS.YES_NO.NO
                            ]}
                            lable={this.props.driverIndex == 0
                                ? "Are you eligible for Defensive Driver Discount?"
                                : 'Are ' + this.props.driver.firstName.toUpperCase() + ' ' + this.props.driver.lastName.toUpperCase() + ' eligible for Defensive Driver Discount?'}
                            tooltip={{ title: "Defensive Driver", content: "Need proof of current defensive driver course completion." } as IToolTipOption}
                            />
                        :null
                    }

                    {
                        this.props.stateCode === "TX"
                        ?
                            !this.props.driver.isExcluded && this.props.driverAge >= 71
                                ?
                                <Question
                                    name="physiciansReport"
                                    selected={(v) => { this.setStateValue(v, "physiciansReport") }}
                                    selectedValue={this.state.physiciansReport}
                                    error={validationUtils.getValidationErrorFor(this.state.errors, "physiciansReport")}
                                    items={[
                                        QUOTE_QUESTIONS.YES_NO.YES,
                                        QUOTE_QUESTIONS.YES_NO.NO
                                    ]}
                                    lable={this.props.driverIndex == 0
                                        ? "Do you have a Physician's Report?"
                                        : "Are " + this.props.driver.firstName.toUpperCase() + " " + this.props.driver.lastName.toUpperCase() + " have a Physician's Report?"}
                                    tooltip={{ title: "Physician's Report", content: "Driver�s age 71 or older need a completed Physician�s Report" } as IToolTipOption}
                                />
                                : null
                        :
                        null
                    }

                    {
                        !this.props.driver.isExcluded
                            ?
                            <Question
                                name="accidentsViolations"
                                selected={(v) => { this.onAccidentsViolationsChange(v) }}
                                selectedValue={this.state.accidentsViolations}
                                error={validationUtils.getValidationErrorFor(this.state.errors, "accidentsViolations")}
                                items={[
                                    QUOTE_QUESTIONS.YES_NO.YES,
                                    QUOTE_QUESTIONS.YES_NO.NO
                                ]}
                                disabled={this.state.loadingViolationsList}
                                lable={this.props.driverIndex == 0
                                    ? "Have you had any accidents, moving violations, or claims in the last 3 years?"
                                    : 'Have ' + this.props.driver.firstName.toUpperCase() + ' ' + this.props.driver.lastName.toUpperCase() + ' had any accidents, moving violations, or claims in the last 3 years?'}
                            />
                            :
                            null
                    }


                    {
                        this.state.loadingViolationsList
                        ? <div className={"w-100 loading-indicator"}><ReactLoading type={"spin"} color={"#007bff"} height={'40px'} width={'40px'} /></div>
                        : null
                    }

                    {
                        !this.props.driver.isExcluded && this.state.accidentsViolations == QUOTE_QUESTIONS.YES_NO.YES
                            ?
                            this.state.driver.incidents.map((incident, index) => (
                                <IncidentInfo
                                    key={Utilities.uniqueId()}
                                    incident={incident}
                                    violations={this.props.violationList}
                                    index={index}
                                    onChange={this.onIncidentChange}
                                    onDelete={this.onIncidentDelete}
                                    errors={this.state.errors}
                                />
                            ))
                            :
                            null
                    }

                    {
                        !this.props.driver.isExcluded && this.state.accidentsViolations == QUOTE_QUESTIONS.YES_NO.YES
                            ?
                            <div className="btnContainer">
                                <Button
                                    className="btnAddViolation"
                                    onClick={() => { this.onIncidentAdd() }}
                                    disabled={this.state.updatingStore}> <i className="fas fa-plus"></i> Add another violation
                                </Button>
                            </div>
                            :
                            null
                    }

                    <div className="btnContainer">
                        <Button
                            className="btnAddDriver"
                            onClick={() => { this.onAddDriverClick() }}
                            disabled={this.state.loadingViolationsList || this.state.updatingStore}>{this.state.updatingStore && this.state.addDriverClick ? <ReactLoading type={"spin"} className="continue-loading" color={"#389BFF"} height={'20px'} width={'20px'} /> : <i className="fas fa-plus"></i>} Add another driver
                        </Button>

                        <div className="orText"><p>or</p></div>

                        <ButtonContinue
                            disabled={this.state.loadingViolationsList || this.state.updatingStore}
                            showLoading={this.state.updatingStore && this.state.continueClick}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);

    var driver = state.drivers[driverIndex];
    const driverAge = moment(new Date()).diff(driver.birthDate, 'years');

    console.log("driverAge: " + driverAge);

    var props = mapDriverStepProps(state, ownProps);
    props["driversCount"] = state.drivers.length;
    props["stateCode"] = state.stateCode;
    props["driver"] = driver;
    props["insured"] = driverIndex > 0 ? state.drivers[0] : null;
    props["secondDriver"] = state.drivers.length >= 2 && driverIndex == 0 ? state.drivers[1] : null;
    props["driverAge"] = driverAge;
    props["violationList"] = state.violationList;
    props["stateCode"] = state.stateCode;

    return props;
}

let mapDispatch = (dispatch: any, ownProps: IDrivingHistoryProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.DRIVING_HISTORY)),
        updateAppState: (update) => dispatch(quoteActions.updateDriver(update.quoteUid, update.driver, QUOTE_STEPS.DRIVING_HISTORY, ownProps.stateCode)),
        updateViolationList: (update: IViolationList) => dispatch(quoteActions.updateViolatioList(update))
    };
};

export default connect(mapProps, mapDispatch)(DrivingHistory);
